export default [
  {
    title:  'Plans menu',
    icon: 'ClipboardIcon',
    name:'dashboard',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Garden Plan',
        name: 'plans.garden.list',
        route: 'plans.garden.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.garden'
        }
      },
    
      {
        title: 'Rain Plan',
        name: 'plans.rain.list',
        route: 'plans.rain.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.rain'
        }
      },
    
      {
        title: 'Utility Plan',
        name: 'plans.utility.list',
        route: 'plans.utility.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.utility'
        }
      },
    
      {
        title: 'Landfill Plan',
        name: 'plans.landfill.list',
        route: 'plans.landfill.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.landfill'
        }
      },
    
      {
        title: 'Sweep Plan',
        name: 'plans.sweep.list',
        route: 'plans.sweep.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.sweep'
        }
      },
    
      {
        title: 'Dump Plan',
        name: 'plans.dump.list',
        route: 'plans.dump.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.dump'
        }
      },
      {
        title: 'Container Pest Plan',
        name: 'plans.containerPest.list',
        route: 'plans.containerPest.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.containerPest'
        }
      },

      {
        title: 'CONTAINER_AREA_PLAN_TITLE',
        name: 'plans.containerArea.list',
        route: 'plans.containerArea.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.containerArea'
        }
      },
    
      {
        title: 'Support Devices',
        name: 'plans.supportDevice.list',
        route: 'plans.supportDevice.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.supportDevice'
        }
      },
    
    
      {
        title: 'Drainage Plan',
        name: 'plans.drainage.list',
        route: 'plans.drainage.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.drainage'
        }
      },
      {
        title: 'Network Plans',
        name: 'plans.network.list',
        route: 'plans.network.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.network'
        }
      },
      {
        title: 'Pest Control Plan',
        name: 'plans.pestControl.list',
        route: 'plans.pestControl.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.pest'
        }
      },
      {
        title: 'Wash Plans',
        name: 'plans.wash.list',
        route: 'plans.wash.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.wash'
        }
      },
      {
        title: 'Container Wash Plans',
        name: 'plans.containerWash.list',
        route: 'plans.containerWash.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.containerWash'
        }
      },
      {
        title: 'RFID Readers Plans',
        name: 'plans.containerDump.list',
        route: 'plans.containerDump.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.containerDump'
        }
      },

      {
        title: 'RFID Washer Plans',
        name: 'plans.washer.list',
        route: 'plans.washer.list',
        icon: 'ClipboardIcon',
        meta: {
          module: 'plans.washer'
        }
      },
    
    ],
  },
]
